import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Typography } from "@mui/material";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
const ApexChart = () => {
    // State for the selected filter
    const [loading, setLoading] = useState(false);

    const [filter, setFilter] = useState("months");

    const [weekData, setWeekData] = useState({});
    const [monthData, setMonthData] = useState({});
    const [yearData, setYearData] = useState({});

    useEffect(() => {
        getLineChartData();
    }, []);

    const getLineChartData = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getLineChartData",
                pk_user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (Object.keys(output).length > 0) {
                setWeekData({
                    weekArr: output["weekData"].map((row) => row.week),
                    countArr: output["weekData"].map((row) => row.reg_count),
                });
                setMonthData({
                    monthArr: output["monthData"].map((row) => row.month),
                    countArr: output["monthData"].map((row) => row.reg_count),
                });
                setYearData({
                    yearArr: output["yearData"].map((row) => row.year),
                    countArr: output["yearData"].map((row) => row.reg_count),
                });
            } else {
                // toast.error("Oops! Something went wrong.", { autoClose: 3000 });
            }
        } catch (error) {
            // toast.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Example function to generate data based on the filter
    const generateChartData = (filter) => {
        switch (filter) {
            case "weeks":
                if (!Array.isArray(weekData["countArr"]) || weekData["countArr"].length === 0) {
                    return { series: [], options: {} };
                }
                return {
                    series: [
                        {
                            name: "Weekly Data",
                            data: weekData["countArr"],
                        },
                    ],
                    options: {
                        chart: {
                            type: "line",
                        },
                        stroke: {
                            curve: "smooth", // Smooth edges
                            width: 2, // Line width
                            colors: ["#262626"], // Line color
                        },
                        xaxis: {
                            categories: weekData["weekArr"],
                        },
                        fill: {
                            type: "gradient", // Optional: adds gradient fill for smoother visual effect
                            gradient: {
                                shade: "light",
                                type: "horizontal",
                                shadeIntensity: 0.5,
                                gradientToColors: ["#262626"], // Change to desired color
                                inverseColors: false,
                                opacityFrom: 0.7,
                                opacityTo: 0.5,
                                stops: [0, 100],
                            },
                        },
                        markers: {
                            size: 4, // Marker size
                            colors: ["#262626"], // Marker color
                        },
                        legend: {
                            position: "top",
                            horizontalAlign: "center",
                            floating: true,
                            offsetY: -10,
                            itemMargin: {
                                horizontal: 10,
                                vertical: 0,
                            },
                        },
                    },
                };
            case "months":
                if (!Array.isArray(monthData["countArr"]) || monthData["countArr"].length === 0) {
                    return { series: [], options: {} };
                }
                return {
                    series: [
                        {
                            name: "Monthly Data",
                            data: monthData["countArr"],
                        },
                    ],
                    options: {
                        chart: {
                            type: "line",
                        },
                        stroke: {
                            curve: "smooth", // Smooth edges
                            width: 2, // Line width
                            colors: ["#262626"], // Line color
                        },
                        xaxis: {
                            categories: monthData["monthArr"],
                        },
                        fill: {
                            type: "gradient", // Optional: adds gradient fill for smoother visual effect
                            gradient: {
                                shade: "light",
                                type: "horizontal",
                                shadeIntensity: 0.5,
                                gradientToColors: ["#262626"], // Change to desired color
                                inverseColors: false,
                                opacityFrom: 0.7,
                                opacityTo: 0.5,
                                stops: [0, 100],
                            },
                        },
                        markers: {
                            size: 4, // Marker size
                            colors: ["#262626"], // Marker color
                        },
                        legend: {
                            position: "top",
                            horizontalAlign: "center",
                            floating: true,
                            offsetY: -10,
                            itemMargin: {
                                horizontal: 10,
                                vertical: 0,
                            },
                        },
                    },
                };
            case "years":
                if (!Array.isArray(yearData["countArr"]) || yearData["countArr"].length === 0) {
                    return { series: [], options: {} };
                }
                return {
                    series: [
                        {
                            name: "Yearly Data",
                            data: yearData["countArr"],
                        },
                    ],
                    options: {
                        chart: {
                            type: "line",
                        },
                        stroke: {
                            curve: "smooth", // Smooth edges
                            width: 2, // Line width
                            colors: ["#262626"], // Line color
                        },
                        xaxis: {
                            categories: yearData["yearArr"],
                        },
                        fill: {
                            type: "gradient", // Optional: adds gradient fill for smoother visual effect
                            gradient: {
                                shade: "light",
                                type: "horizontal",
                                shadeIntensity: 0.5,
                                gradientToColors: ["#262626"], // Change to desired color
                                inverseColors: false,
                                opacityFrom: 0.7,
                                opacityTo: 0.5,
                                stops: [0, 100],
                            },
                        },
                        markers: {
                            size: 4, // Marker size
                            colors: ["#262626"], // Marker color
                        },
                        legend: {
                            position: "top",
                            horizontalAlign: "center",
                            floating: true,
                            offsetY: -10,
                            itemMargin: {
                                horizontal: 10,
                                vertical: 0,
                            },
                        },
                    },
                };
            default:
                return {
                    series: [],
                    options: {},
                };
        }
    };

    const chartData = generateChartData(filter);

    const hasData = chartData.series && chartData.series.length > 0 && chartData.series[0].data.length > 0;


    return (
        <>
            <div className="card-title d-flex justify-content-between align-items-center mb-3">
                <h4 className="">Joining</h4>
                <div className="btn-group" role="group" aria-label="Filter options">
                    <button
                        type="button"
                        onClick={() => setFilter("weeks")}
                        className={`btn btn-outline-secondary btn-sm ${filter === "weeks" ? "active" : ""}`}
                    >
                        Weeks
                    </button>
                    <button
                        type="button"
                        onClick={() => setFilter("months")}
                        className={`btn btn-outline-secondary btn-sm ${filter === "months" ? "active" : ""}`}
                    >
                        Months
                    </button>
                    <button
                        type="button"
                        onClick={() => setFilter("years")}
                        className={`btn btn-outline-secondary btn-sm ${filter === "years" ? "active" : ""}`}
                    >
                        Years
                    </button>
                </div>
            </div>
            <div className="chart-container">
            {hasData ? (
                <Chart
                    options={chartData.options}
                    series={chartData.series}
                    type="line"
                    height="398px" // Adjust as needed to fit the card height
                />
                ) : (
                    <Typography variant="h6" color="textSecondary" align="center" display="flex" justifyContent="center" alignItems="center" height={380}>
                        No Data Available
                    </Typography>
                )}
            </div>
        </>
    );
};

export default ApexChart;
